import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import biharLogo from "../../assets/images/bihar-logo-red.png";
import "./officerShell.css";

import { DEO, BEO, isOfficer, officerHomePath, OFFICER_DESIGNATIONS } from "./officers";
import { useOfficerAccess, SECTIONS } from "./access";

export { isOfficer, officerHomePath, OFFICER_DESIGNATIONS };

const buildNav = (auth) => {
    const designation = auth?.vchDesignationName;
    const isBEO = designation === BEO;
    const isDEO = designation === DEO;

    const items = [
        {
            key: "home",
            label: "Home",
            short: "Home",
            icon: "fa-home",
            to: officerHomePath(auth),
            match: (p) => p.startsWith("/pendency-officer") || p.startsWith("/officer/dash")
                || p.startsWith("/officer/complain") || p.startsWith("/officer/actionLog"),
        },
        {
            key: "schoolvc",
            section: SECTIONS.SCHOOL_VC_REPORT,
            label: "VC / School Report",
            short: "Reports",
            icon: "fa-bar-chart",
            to: isBEO
                ? `/officer/school-vc-data/SCHOOL/BLOCK/${auth.blockName}`
                : "/officer/school-vc-data/SCHOOL/DISTRICT",
            match: (p) => p.startsWith("/officer/school-vc-data"),
        },
    ];

    items.push(
        {
            key: "school",
            section: SECTIONS.SCHOOL_UPLOAD,
            label: "Add School Document",
            short: "School",
            icon: "fa-camera",
            to: "/school-report",
            match: (p) => p.startsWith("/school-report"),
        },
        {
            key: "vc",
            section: SECTIONS.VC_UPLOAD,
            label: "Add VC Document",
            short: "VC",
            icon: "fa-video-camera",
            to: "/vc-report",
            match: (p) => p.startsWith("/vc-report"),
        },
        {
            key: "category",
            section: SECTIONS.CATEGORY_REPORT,
            label: "Category Report",
            short: "Category",
            icon: "fa-th-list",
            to: isDEO
                ? `/pendency-category?type=DISTRICT&code=${auth.districtCode}&category=all&date=`
                : isBEO
                    ? `/pendency-view?blockCode=${auth.blockName}&category=New`
                    : "/pendency-category?type=STATE&code=0&category=all&date=",
            match: (p) => p.startsWith("/pendency-category") || p.startsWith("/pendency-view"),
        }
    );

    return items;
};

const initials = (name = "") =>
    name.replace(/[^A-Za-z ]/g, " ").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "O";

const OfficerShell = ({ auth }) => {
    const { pathname } = useLocation();
    const { can } = useOfficerAccess();
    // Home is always available; every other section is admin-controlled.
    const nav = buildNav(auth).filter((item) => !item.section || can(item.section));
    const displayName = auth?.fullName || auth?.vchfullName;

    useEffect(() => {
        document.body.classList.add("ofc-body");
        return () => document.body.classList.remove("ofc-body");
    }, []);

    return (
        <>
            <header className="ofc-topbar">
                <Link to={officerHomePath(auth)} className="ofc-brand">
                    <img src={biharLogo} alt="Government of Bihar" />
                    <span className="ofc-brand__text">
                        <strong>Command &amp; Control Centre</strong>
                        <small>Education Department, Bihar</small>
                    </span>
                </Link>

                <div className="ofc-user">
                    <span className="ofc-user__avatar">{initials(displayName)}</span>
                    <span className="ofc-user__text">
                        <strong>{displayName}</strong>
                        <small>{auth?.vchDesignationName}</small>
                    </span>
                    <a href="/logout" className="ofc-user__logout" title="Logout" aria-label="Logout">
                        <i className="fa fa-sign-out" />
                    </a>
                </div>
            </header>

            <nav className="ofc-nav" aria-label="Officer navigation">
                {nav.map((item) => {
                    const active = item.match(pathname);
                    return (
                        <Link
                            key={item.key}
                            to={item.to}
                            className={`ofc-nav__item${active ? " is-active" : ""}`}
                            aria-current={active ? "page" : undefined}
                        >
                            <i className={`fa ${item.icon}`} aria-hidden="true" />
                            <span className="ofc-nav__label">{item.label}</span>
                            <span className="ofc-nav__short">{item.short}</span>
                        </Link>
                    );
                })}
            </nav>
        </>
    );
};

const mapStateToProps = (state) => ({ auth: state.Auth?.auth });

export default connect(mapStateToProps)(OfficerShell);
